// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1E0qK","options":"AnswerScale_options__2pBl0","selected":"AnswerScale_selected__1UWIu"};